import axios from 'axios';
import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_PROFILE_SECTION = 'GET_PROFILE_SECTION';
export const GET_PROFILE_SECTION_SUCCESS = 'GET_PROFILE_SECTION_SUCCESS';
export const GET_PROFILE_SECTION_FAILURE = 'GET_PROFILE_SECTION_FAILURE';

// Action Creators
export const getProfileSection = () => ({
  type: GET_PROFILE_SECTION,
});

export const getProfileSectionSuccess = (users) => ({
  type: GET_PROFILE_SECTION_SUCCESS,
  payload: users,
});

export const getProfileSectionFailure = (error) => ({
  type: GET_PROFILE_SECTION_FAILURE,
  payload: error,
});

// Thunk Function
export const getProfileSectionData = (external) => {
  return async (dispatch) => {
    dispatch(getProfileSection());
    try {
      const response = await getMethodWithToken(url?.doctorProfileSection);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getProfileSectionSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getProfileSectionFailure(error?.message));
    }
  };
};
